import i18n, { InitOptions } from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./translations/en.json";
import nl from "./translations/nl.json";
import fr from "./translations/fr.json";
import { useTemplateStore } from "./taskpane/stores/templateStore";
import { isDev } from "./util";

export type Language = "en" | "nl" | "fr";

const options: InitOptions<unknown> = {
  resources: {
    en: { translation: en },
    nl: { translation: nl },
    fr: { translation: fr },
  },
  fallbackLng: "en",
  supportedLngs: ["en", "nl", "fr"],
  interpolation: {
    escapeValue: false, // React already escapes
  },
};

const SUPPORTED: readonly Language[] = ["en", "nl", "fr"];

export function detectOfficeLanguage(): Language | undefined {
  const tag = Office?.context?.displayLanguage ?? Office?.context?.contentLanguage;
  const primary = tag?.split("-")[0]?.toLowerCase() as Language | undefined;
  return primary && SUPPORTED.includes(primary) ? primary : undefined;
}

export async function applyOfficeLanguage() {
  const language = detectOfficeLanguage();
  if (!language || language === i18n.language) return;

  if (isDev) console.log(`Setting initial language from Office: ${i18n.language} -> ${language}`);
  await i18n.changeLanguage(language);
}

export async function switchLanguage(languageCode: Language) {
  if (isDev) console.log(`Changing language from ${i18n.language} to ${languageCode}`);
  await i18n.changeLanguage(languageCode);
  await useTemplateStore.getState().fetchItems(); // Refetch content from the server
}

void i18n.use(initReactI18next).init(options);
